import { useState, useEffect } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import axios from "axios";
import config from "../config";
import localCategories from "../data/categories.json"; // ← import fallback JSON

const reasonsToChoose = [
  "Personalized Service",
  "Transparent Fee Structure",
  "Timely Delivery",
  "End-to-End Financial Support",
  "Committed to Ethics & Confidentiality",
];

function OurServices() {
  const [servicesData, setServicesData] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await axios.get(`${config.apiBaseURL}/Categories/GetHierchy`);
      if (response?.data && Array.isArray(response.data)) {
        setServicesData(response.data);
      } else {
        console.warn("API returned invalid data, using local JSON instead.");
        setServicesData(localCategories);
      }
    } catch (error) {
      console.error("API error, using local JSON fallback:", error);
      setServicesData(localCategories);
    } finally {
      setLoading(false);
    }
  };

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (loading) {
    return (
      <div className="page-title" data-aos="fade">
        <div className="container text-center py-20 text-lg text-gray-600">
          Loading services...
        </div>
      </div>
    );
  }

  return (
    <>
      {/* --- Page Title --- */}
      <div className="page-title" data-aos="fade">
        <div className="container">
          <nav className="breadcrumbs">
            <ol>
              <li><a href="/">Home</a></li>
              <li className="current">Our Services</li>
            </ol>
          </nav>
          <h1>Our Services</h1>
        </div>
      </div>

      {/* --- Services Section --- */}
      <section id="our-services" className="section">
        <div className="container">
          <p>
            At CA Sanjay Prasad & Associates, we offer professional services tailored
            to your business and individual needs. Explore our offerings below:
          </p>

          <div className="accordion">
            {servicesData.map((service, index) => (
              <div key={service.categoryId} className="accordion-item">
                <button
                  className="accordion-title"
                  onClick={() => toggleAccordion(index)}
                >
                  <span>{service.categoryName}</span>
                  {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                </button>

                {openIndex === index && service.children?.length > 0 && (
                  <ul className="accordion-content">
                    {service.children.map((child) => (
                      <li key={child.categoryId}>{child.categoryName}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>

          <br />

          {/* --- Why Choose Section --- */}
          <h2>Why Choose Me?</h2>
          <ul className="why-choose-us">
            {reasonsToChoose.map((reason, i) => (
              <li key={i}>✔ {reason}</li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}

export default OurServices;
